import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { securityPageResource } from '@jira/router-resources__software-security/src/securityPageResource.tsx';
import { softwareSecurityNextGenRoute } from '@jira/router-routes__software-security-routes/src/softwareSecurityNextGenRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { isSecurityPageEnabled } from './common/isSecurityPageEnabled.tsx';
import { securityPageEntrypoint, securityDeprecatedPageEntrypoint } from './common/security.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareSecurityNextGenRouteEntry: Route = createEntry(
	softwareSecurityNextGenRoute,
	() => ({
		group: 'software',
		layout: softwareProjectLayoutNoOnboarding,
		ufoName: 'software-security-combined',

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			resourceWithCondition(
				() => !fg('jira-security-page-to-ugs-v2') && !fg('jolt-security-page-deprecated'),
				securityPageResource,
			),
		],

		meta: {
			reporting: {
				id: 'software-security',
				packageName: camelCase('software-security'),
				teamName: 'jolt',
			},
		},

		entryPoint: () => {
			// When the Security tab is deprecated, serve the "moved to Development" page regardless of
			// `isSecurityPageEnabled()` so users who navigate to the old URL still see the deprecation
			// page rather than a not-found page.
			if (fg('jolt-security-page-deprecated')) {
				return securityDeprecatedPageEntrypoint;
			}
			return isSecurityPageEnabled() ? securityPageEntrypoint : notFoundPageEntrypoint;
		},
		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
